import { Checkbox, FormControlLabel } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { SelectItem } from '@/types/fields';

export interface Props<ItemValueType extends string | number> {
  readonly item: SelectItem<ItemValueType>;
  readonly checked: boolean;
}

export function ItemWithCheckbox<ItemValueType extends string | number>(
  props: Props<ItemValueType>,
): React.ReactElement {
  const { item, checked } = props;
  const tr = useTranslator();

  return (
    <Box width="100%">
      <FormControlLabel
        sx={styles.control}
        control={<Checkbox size="small" defaultChecked={checked} tabIndex={0} />}
        label={
          <Typography fontSize={16} whiteSpace="nowrap" color="text.primary">
            {tr(item.label)}
          </Typography>
        }
      />
    </Box>
  );
}

const styles: Record<string, SystemStyleObject> = {
  control: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    height: '1.5em',
    gap: 1,
  },
};
